import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import Button from '@material-ui/core/Button'; // Changed this line
import SnackbarAlert from '../../components/SnackbarAlert';
import { config } from '../../config';
import { useAuth } from '../../hooks/useAuth';
import { useSearchParams } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useSelector, useDispatch } from 'react-redux';
import CleaningReport from '../../components/CleaningReport';
import { showSnackbar, setResponse, setActiveTab } from '../../state/actions-creators';
import './App.css';
import Alert from '@material-ui/lab/Alert';  // Add this import

const MediumFont = styled.span`
  font-size: calc(1px + 2.5vmin);
`;
const mediumFont = 'calc(1px + 2.5vmin)';
const AppDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 480px;
  background-color: #fff;
`;
const LargeHeader = styled.h1`
  font-size: calc(1px + 7vmin);
`;
const Page = styled.div`
  width: 40vw;
`;

const AreaText = styled.p`
  font-size: ${mediumFont};
  font-weight: bold;
  margin-top: 2vh;
`;

const ProgressText = styled.span`
  font-size: ${mediumFont};
  font-weight: 500;
  margin-top: 0vh;
  margin-left: 0vh;
`;

// http://localhost:3000/roomcleaned?organization=183&location=243&id=112217182
const RoomCleaned = () => {
  const { token } = useAuth();
  const [searchParams] = useSearchParams();
  const [roomName, setRoomName] = useState('');
  const [isClicked, setIsClicked] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(!token);

  const isValidRoom = Boolean(roomName && roomName.trim().length > 0);

  /* Renders the 2 tabs of the application */
  const activeTab = useSelector((state) => state.activeTab);
  const dispatch = useDispatch();

  const handleRoomCleaned = async () => {
    try {
      if(!isClicked) setIsClicked(true)
      const orgid = searchParams.get('organization');
      const locid = searchParams.get('location');
      const assetid = searchParams.get('id');

      fetch(`${config.lnt_api_url}/roomcleaned?id=${assetid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          orgId: orgid,
          locationId: locid,
          area: roomName,
          token: token,
        }),
      })
        .then((response) => {
          console.log(response.status);
          dispatch(showSnackbar());
          dispatch(setResponse(response.status));
        })
        .catch((err) => {
          console.log('Error in Apollo.js, calling /v1/reset');
          console.log(err);

        });


    } catch (e) {
      console.log(e);
    } finally {
      console.log("Ok");
    }
  };

  useEffect(() => {
    const fetchAssetDetails = async () => {
      if (!token) return; // Don't proceed without token
      
      setIsLoading(true);
      const api = axios.create({
        baseURL: 'https://eu-api.empathicbuilding.com/v1',
        headers: { Authorization: `Bearer ${token}` },
      });
      const orgid = searchParams.get('organization');
      const locid = searchParams.get('location');
      const assetid = searchParams.get('id');
      const asset_url = `https://eu-api.empathicbuilding.com/v1/organizations/${orgid}/locations/${locid}/assets/${assetid}`;
      let room = []
      let assets = []
      try {
        assets = await api.get(asset_url);
        room = assets.data;
        setRoomName(room?.name || '');
        
        if (!room?.name) {
          setError('Name is required.\nPlease inform your superior quickly about missing name.\nAlueen nimi puuttuu. Ilmoita asiasta pikaisesti esihenkillöllesi.');
        } else {
          setError('');
        }
      } catch (e) {
        console.log(e);
        setError('Failed to fetch room details');
      } finally {
        setIsLoading(false);
      }
    };
    fetchAssetDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, searchParams]);

  // First check for loading state
  if (isLoading) {
    return (
      <AppDiv>
        <LargeHeader>Room cleaned App</LargeHeader>
        <Page>
          <AreaText>Loading...</AreaText>
        </Page>
      </AppDiv>
    );
  }

  // Only validate after initialization is complete
  if (!isValidRoom) {
    return (
      <AppDiv>
        <LargeHeader>Room cleaned App</LargeHeader>
        <Page>
          <AreaText>
            Chosen area: <ProgressText>Not Set</ProgressText>
          </AreaText>
          <Alert severity="error" style={{ marginTop: '1rem', whiteSpace: 'pre-line' }}>
            {'Name is required.\nPlease inform your superior quickly about missing name.\nAlueen nimi puuttuu. Ilmoita asiasta pikaisesti esihenkillöllesi.'}
          </Alert>
        </Page>
      </AppDiv>
    );
  }

  return (
    <AppDiv>
      <LargeHeader>Room cleaned App</LargeHeader>
      <Page>
        <Tabs>
          <TabList>
            <Tab
              style={{
                backgroundColor: activeTab === 'app' ? '#d9d9d9' : null,
              }}
              onClick={() => dispatch(setActiveTab('app'))}
            >
              <MediumFont>Cleaning App</MediumFont>
            </Tab>
            <Tab
              style={{
                backgroundColor: activeTab === 'report' ? '#d9d9d9' : null,
              }}
              onClick={() => dispatch(setActiveTab('report'))}
            >
              <MediumFont>Report</MediumFont>
            </Tab>
          </TabList>

          <TabPanel>
            <AreaText>
              Chosen area: <ProgressText>{roomName}</ProgressText>
            </AreaText>
            {error ? (
              <Alert severity="error" style={{ marginTop: '1rem' }}>
                {error}
              </Alert>
            ) : (
              <Button
                color="primary"
                variant="contained"
                disabled={isClicked}
                size="large"
                onClick={handleRoomCleaned}
              >
                Area Cleaned
              </Button>
            )}
          </TabPanel>
          <TabPanel>
            <CleaningReport />
          </TabPanel>
        </Tabs>
      </Page>
      <SnackbarAlert></SnackbarAlert>
    </AppDiv>
  );
};

export default RoomCleaned;
